import React from 'react';
import UseVimeoPreview from "./VimeoPreview.hooks";
import { makeVimeoTemplate } from '../embedUtilities';



const VimeoPreview = ({url, setDisableUpload, setIsLoading, isLoading, setEmbedId}:{url: string, setDisableUpload: any, setIsLoading: any, isLoading: boolean, setEmbedId:any}) => {
    
    const {id} = UseVimeoPreview(url, isLoading, setIsLoading, setDisableUpload);

    if (isLoading) {
        return <div className="spacer" />
    }

    if (!id) {
        return <span className="error-message">We couldn't find a source for that Vimeo embed. Please try again.</span>
    } else {
        setEmbedId(id);

        return ( 
            <div className='embed-preview-container vimeo-preview'>
                <div className="preview-tab">Preview</div>
                    
                <div dangerouslySetInnerHTML={{__html:makeVimeoTemplate(id)}}/>
            </div>
        )
    }
}

export default VimeoPreview